module.exports = __webpack_public_path__ + "img/L_6D.689375bf.png";